export default __webpack_public_path__ + "static/media/access_control_locations_icons_school.c4189980.svg";